import { render, staticRenderFns } from "./Symbol.vue?vue&type=template&id=28f466cf&scoped=true"
import script from "./Symbol.vue?vue&type=script&lang=js"
export * from "./Symbol.vue?vue&type=script&lang=js"
import style0 from "./Symbol.vue?vue&type=style&index=0&id=28f466cf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f466cf",
  null
  
)

export default component.exports